// keycloak-wrapper.js
import {
  getToken as realGetToken,
  useKeycloak as realUseKeycloak,
} from "@josempgon/vue-keycloak";
import { SKIP_AUTH } from "./env";

export async function getToken() {
  if (SKIP_AUTH) {
    // Dummy token when skipping authentication
    return "dummy_token";
  } else {
    // Otherwise, use the library’s exported getToken function.
    return await realGetToken();
  }
}

export async function useKeycloak() {
  if (SKIP_AUTH) {
    // Dummy token when skipping authentication
    return { "username": "dev" };
  } else {
    // Otherwise, use the library’s exported getToken function.
    return await realUseKeycloak();
  }
}
